import React, { useState } from "react";
import "../../../assets/css/Home2.css";
import Home2Navbar from "../../Common/Home2Navbar";
import Home2Footer from "../../Common/Home2Footer";

const BecomeCounsellor = () => {
  const [activeTab, setActiveTab] = useState("personal");

  const renderFormContent = () => {
    switch (activeTab) {
      case "personal":
        return (
          <>
            <h2 className="text-xl font-semibold mb-4">Counselor Application</h2>
            <p className="text-sm mb-6">
              Join our network of specialized mental health professionals.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Enter your first name"
                className="input w-full"
              />
              <input
                type="text"
                placeholder="Enter your last name"
                className="input w-full"
              />
              <input
                type="email"
                placeholder="Enter your email"
                className="input w-full md:col-span-2"
              />
              <input
                type="text"
                placeholder="Enter your phone number"
                className="input w-full md:col-span-2"
              />
              <input
                type="text"
                placeholder="City, State/Province, Country"
                className="input w-full md:col-span-2"
              />
            </div>
          </>
        );
      case "professional":
        return (
          <>
            <h2 className="text-xl font-semibold mb-4">Professional Background</h2>
            <textarea
              placeholder="Describe your professional experience"
              className="input w-full h-32"
            />
          </>
        );
      case "fees":
        return (
          <>
            <h2 className="text-xl font-semibold mb-4">Availability & Fees</h2>
            <input
              type="text"
              placeholder="Your availability schedule"
              className="input w-full mb-4"
            />
            <input
              type="text"
              placeholder="Your consultation fee"
              className="input w-full"
            />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Home2Navbar />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="container mx-auto">
          <div className="w-full max-w-2xl mx-auto p-6 sm:p-8 bg-white rounded-xl shadow-md">
            <h1 className="text-2xl font-bold text-center mb-2">Apply to Join</h1>
            <p className="text-center text-gray-500 mb-6">
              Complete the form below to start the application process. Our team
              will review your information and contact you for the next steps.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-2 mb-6">
              <button
                className={`tab ${activeTab === "personal" ? "tab-active" : ""}`}
                onClick={() => setActiveTab("personal")}
              >
                Personal Information
              </button>
              <button
                className={`tab ${activeTab === "professional" ? "tab-active" : ""}`}
                onClick={() => setActiveTab("professional")}
              >
                Professional Background
              </button>
              <button
                className={`tab ${activeTab === "fees" ? "tab-active" : ""}`}
                onClick={() => setActiveTab("fees")}
              >
                Availability & Fees
              </button>
            </div>

            <div className="form-content space-y-4">{renderFormContent()}</div>
          </div>
        </div>
      </div>
      <Home2Footer />
    </>
  );
};

export default BecomeCounsellor;
